
import { MULTICURRENCY_RECHARGE, MULTICURRENCY_PAYCONFIRM } from "../apis/payment"

export default {
  data() {
    return {
      query_timer: 0,
      query_pay_num: 0
    }
  },
  methods: {
    // 多货币支付方式
    onMulticurrencyPayment(payMode, callback) {
      this.MulticurrencyRecharge(callback)
    },
    /** 多货币充值方式
     * https://app.apifox.com/link/project/1121455/apis/api-265418758
     */
    async MulticurrencyRecharge(callback) {
      try {
        let rechargeType = "balance";
        if (this.payType === "PO") rechargeType = "pay";
        if (this.payType === "VIP") rechargeType = "vip";
        const query = {
          "paymentId": this.pId,
          "amount": this.price || "",
          "rechargeType": rechargeType,
          "userOpenId": this.user.p_openID,
          "rentNow": rechargeType === 'balance',
          "qrCode": this.qrcode || this.$route.query.cabinetID || ""
        }
        const headers = { headers: { "Content-Type": "application/json;charset=UTF-8" } }
        this.$loading(true)
        const { data = {} } = await this.$Request("POST", MULTICURRENCY_RECHARGE, query, headers)
        const Payment = this.selectPayment || { paymentMethodType: '' };
        if (data.outTradeNo && Payment.paymentMethodType.includes('Alipay')) {
          this.queryPaymentConfirm(data, callback);
          window.location.href = data.paymentInfo.payUrl;
          return false;
        }
        if (data.outTradeNo && data.approvalUrl) {
          window.location.href = data.approvalUrl;
          return false;
        }
        throw new Error(data.message);
      } catch (err) {
        this.$loading(false)
        this.$toast(err)
        console.warn("Multicurrency ~ err:", err)
      }
    },
    // 多货币确认支付方式
    async MulticurrencyConfirm(outTradeNo, tradeNo) {
      const query = { "outTradeNo": outTradeNo || '', "tradeNo": tradeNo || '' };
      const { data = {} } = await this.$Request("GET", MULTICURRENCY_PAYCONFIRM, query)
      return data;
    },
    // 查询支付确认
    async queryPaymentConfirm(Payment, callback) {
      if (this.query_pay_num > 12) {
        clearTimeout(this.query_timer);
        this.query_pay_num = 0;
        return false;
      }
      const callbackCell = (result) => {
        if (result && result.orderStatus === 1) {
          this.$loading(false)
          callback && callback(Payment);
        } else {
          this.query_pay_num++;
          this.query_timer = setTimeout(() => {
            this.queryPaymentConfirm(Payment, callback);
          }, 2200)
        }
      }
      if (Payment.outTradeNo) {
        await this.MulticurrencyConfirm(Payment.outTradeNo, Payment.tradeNo).then((result) => {
          callbackCell(result);
        }).catch((res) => {
          callbackCell(res);
        });
      }
    }
  }
}
